<template>
  <card
    class="custom-shadow-card-header custom-table-responsive"
    :title="`${$t('production.harvest_by_age_week')} ${
      getSizeFarmList === 1
        ? ` - ${$t('common_words.farm')}: ${farmList[0].name}`
        : ``
    }`"
  >
    <el-container>
      <aside-list
        :addClass="`.el-menu-${option}`"
        @clickItem="handleChangeMenuSelected"
        :label="$t('common_words.farms')"
        :optionIndex="option"
        :list="farmList"
        v-if="getSizeFarmList > 1"
      />
      <el-container v-if="dataFarm && getSizeFarmList > 0">
        <el-main
          :style="
            getSizeFarmList == 1
              ? 'paddingLeft: 0 !important; overflow: hidden;'
              : ''
          "
        >
          <div class="row">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
                filterable
              >
                <el-option
                  class="select-default"
                  v-for="item in perPageOptions"
                  :key="item"
                  :label="item === 0 ? $t('common_words.see_all') : item"
                  :value="item === 0 ? totalRegister(dataFarm.rows) : item"
                >
                </el-option>
              </el-select>
              <el-input
                clearable
                show-word-limit
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="col-12">
              <div class="table-responsive">
                <table class="table table-striped table-bordered">
                  <thead-by-age-week :columns="dataFarm.columns" />
                  <tbody-by-age-week
                    :rows="queriedDataRows(dataFarm.rows)"
                    :columns="dataFarm.columns"
                    :totalRows="dataFarm.totalRows"
                    :data="dataFarm.data"
                  />
                  <tfoot-by-age-week
                    :rows="queriedDataRows(dataFarm.rows)"
                    :columns="dataFarm.columns"
                    :totalColumns="dataFarm.totalColumns"
                    :totalRows="dataFarm.totalRows"
                    :option="option"
                  />
                </table>
              </div>
              <template ref="cardfooter">
                <div
                  slot="footer"
                  class="mt-3 col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                  <div class>
                    <p class="card-category">
                      {{ $t('table2.showing') }}{{ from + 1 }}
                      {{ $t('table2.a') }} {{ toRows(dataFarm.rows) }}
                      {{ $t('table2.of') }} {{ totalRegister(dataFarm.rows) }}
                      {{ $t('table2.entries') }}
                    </p>
                  </div>
                  <l-pagination
                    class="pagination-no-border"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="pagination.total"
                    pageFirst="false"
                    pageLast="false"
                  ></l-pagination>
                </div>
              </template>
            </div>
          </div>
          <div class="row">
            <div class="col-12" v-if="isExcel()">
              <div class="text-center">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportToExcel()"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </card>
</template>
<script>
import { Pagination as LPagination } from 'src/components/index';
import AsideList from 'src/components/Layouts/AsideList.vue';
import MixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import PaginationTable from '../pagination-table';
import Select from 'src/components/Selects/Select.vue';
import TheadReportByAgeAndWeek from './TheadReportByAgeAndWeek.vue';
import TbodyReportByAgeAndWeek from './TbodyReportByAgeAndWeek.vue';
import TfootReportByAgeAndWeek from './TfootReportByAgeAndWeek.vue';

export default {
  name: 'report-by-age-week',
  components: {
    [AsideList.name]: AsideList,
    [Select.name]: Select,
    [TheadReportByAgeAndWeek.name]: TheadReportByAgeAndWeek,
    [TbodyReportByAgeAndWeek.name]: TbodyReportByAgeAndWeek,
    [TfootReportByAgeAndWeek.name]: TfootReportByAgeAndWeek,
    LPagination,
  },
  data() {
    return {
      froms: 0,
      tos: 0,
      totals: 0,
      perPageOptions: [5, 10, 25, 50, 0],
    };
  },
  props: {
    option: {
      type: String,
      default: 'reportByAgeAndWeek',
    },
    farmList: {
      type: Array,
      default: [],
    },
    dataFarm: {
      type: Array | Object,
    },
  },
  computed: {
    getSizeFarmList() {
      if (this.farmList) return Object.keys(this.farmList).length;
      else return 0;
    },
  },
  mixins: [MixinMasters, MixinPermissions],
  methods: {
    ...PaginationTable.Methods,
    handleChangeMenuSelected(data) {
      this.$emit('handleChangeMenuSelected', data);
    },
    exportToExcel() {
      this.$emit('exportToExcel', {
        optionFront: this.option,
        optionBackend: 5,
      });
    },
  },
  watch: {
    dataFarm(value) {
      try {
        this.searchFuse(['name'], this.getRows(this.dataFarm.rows), 0.2);
      } catch (error) {
        console.log(error);
      }
      this.pagination.perPage = 10;
      this.searchQuery = '';
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.getSizeFarmList == 1) {
        this.handleChangeMenuSelected({
          id: this.farmList[0].id,
          option: this.option,
        });
      } else {
        document.getElementsByClassName(`.el-menu-${this.option}`)[0].click();
      }
    }, 100);
  },
};
</script>
